import React, { useEffect } from "react";
import styles from 'components/shared/tables/infiniteScrollTable.module.scss';
import { useSelector } from "react-redux";
import { useAppDispatch } from "app/store";
import { getInvoicesBySubscriptionId } from "features/billing/invoices/invoicesActions";
import { getCouponById } from "features/billing/couponInfo/couponInfoActions";
import { subscriptionInfoSelector } from "features/billing/subscription/subscriptionSlice";
import { invoicesSelector } from "features/billing/invoices/invoicesSlice";
import { IInvoice, InvoiceTableHeadings } from "features/billing/invoices/invoicesTypes";
import { DownloadIcon } from "assets/icons/Menu/DownloadIcon";
import Preloader from "components/shared/Preloader";
import { format } from "date-fns";
import { currenciesListSelector } from "features/currencies/currenciesSlice";

const invoiceTableColumns: Record<'name', InvoiceTableHeadings>[] = [
  { name: 'Date' },
  { name: 'Amount' },
  { name: 'Description' },
  { name: 'Status' },
  { name: 'Download' }
];

const Invoices: React.FC = () => {
  const dispatch = useAppDispatch();

  const currencies = useSelector(currenciesListSelector)
  const subscriptionInfo = useSelector(subscriptionInfoSelector);
  const invoiceInfo = useSelector(invoicesSelector);

  const getCurrencySymbol = (currencyCode: string) => currencies.find(x => x.code.toLowerCase() === currencyCode.toLowerCase())?.symbol ?? currencyCode

  useEffect(() => {
    if (subscriptionInfo?.id) {
      dispatch(getInvoicesBySubscriptionId(subscriptionInfo.id));
    }
    if (subscriptionInfo?.couponId) {
      dispatch(getCouponById(subscriptionInfo.couponId))
    }
  }, [subscriptionInfo, dispatch]);

  const InvoiceTableItem: React.FC<{ invoice: IInvoice }> = ({ invoice }) => {
    return (
      <div className={`${styles.fRow} ${styles.fBodyRow}`} key={invoice.id}>
        <div className={`${styles.fCell} ${styles.fBodyCell}`}>
          <span className={`${styles.fBodyCellContent}`}>
            {format(new Date(invoice.date), 'MMM dd, yyyy')}
          </span>
        </div>
        <div className={`${styles.fCell} ${styles.fBodyCell}`}>
          <span className={`${styles.fBodyCellContent}`}>
            {getCurrencySymbol(invoice.currency)}{invoice.amount ?? 0}
          </span>
        </div>
        <div className={`${styles.fCell} ${styles.fBodyCell}`}>
          <span className={`${styles.fBodyCellContent}`}>
            {invoice.description}
          </span>
        </div>
        <div className={`${styles.fCell} ${styles.fBodyCell}`}>
          <span className={`${styles.fBodyCellContent}`}>
            {invoice.status}
          </span>
        </div>
        <div className={`${styles.fCell} ${styles.fBodyCell}`}>
          <span className={`${styles.fBodyCellContent}`}>
            <a href={invoice.downloadPdfUrl}><DownloadIcon /></a>
          </span>
        </div>
      </div>
    );
  };

  return (
    <>
      {
        invoiceInfo.isLoading ? (
          <Preloader />
        ) : (
          <div className={styles.fTable}>
            <div className={`${styles.fRow} ${styles.fHeaderRow}`}>
              {invoiceTableColumns.map((col) => (
                <div key={col.name} className={`${styles.fCell} ${styles.fHeaderCell}`}>
                  {col.name}
                </div>
              ))}
            </div>
            <div className={styles.fTableBody}>
              {invoiceInfo.invoices.map((invoice) => (
                <InvoiceTableItem invoice={invoice} key={invoice.id} />
              ))}
            </div>
          </div>
        )
      }
    </>
  );
};

export default Invoices;
